import Brett from "./Brett";
import {v3} from "oc-threejs/short3";

export default class Schrankboden extends Brett {
    // DO NOT CHANGE: Brett gilt eigentlich allgemein für z.B. auch Deckel. Deshalb hier dieser Classname
    className = "Brett";

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    constructor(schrank) {
        super(schrank, 'Bodenplatte')
    }

    compile() {
        const outer = this.schrank.corpusBox;
        const inner = this.schrank.elementsBox;

        if (this.schrank.options.getBool('aussenwand_durchgehend_unten')){
            this.box = new THREE.Box3(
                v3(inner.min.x, inner.min.y - this.schrank.options.getFloat('boden_staerke'), outer.min.z),
                v3(inner.max.x, inner.min.y, inner.max.z)
            );
        }
        else{
            this.box = new THREE.Box3(
                v3(outer.min.x, inner.min.y - this.schrank.options.getFloat('boden_staerke'), outer.min.z),
                v3(outer.max.x, inner.min.y, inner.max.z)
            );
        }



        this.box.max.z -= this.schrank.options.getFloat('aussenwand_vorsprung', 0);

        this.boxToVertices();
        super.compile();
    }

}
